import React from 'react';
import { Text } from '@chakra-ui/react';
import './styles.scss';

const Badge = ({ title, color, backgroundColor }) => (
    <Text
        className="bagde-status-global__container"
        data-testid="bagde-status__global"
        style={{
            backgroundColor,
            color,
        }}
    >
        {title}
    </Text>
);

export default Badge;
